import React, { Component, Suspense, lazy } from "react";
import "./RoomToDoTab.css";

const ToDo = lazy(() => import("../../Feeds/ToDo"));

export class RoomToDoErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("[RoomToDoTab] ToDo failed to render", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="email-attachments-empty">
          {(this.props.strings && this.props.strings.something_went_wrong) || "Could not load tasks"}
        </div>
      );
    }
    return this.props.children;
  }
}

export default function RoomToDoTab({ roomId, roomName, onOpenRoomChat, onOpenRoomEmail, strings, headerHost = null, active = true }) {
  return (
    <div className="room-todo-tab">
      <RoomToDoErrorBoundary strings={strings}>
        <Suspense fallback={<div className="room-todo-tab__fallback" />}>
          <ToDo
            embedded
            embeddedRoomId={roomId}
            embeddedRoomName={roomName}
            onOpenRoomChat={onOpenRoomChat}
            onOpenRoomEmail={onOpenRoomEmail}
            headerHost={headerHost}
            active={active}
          />
        </Suspense>
      </RoomToDoErrorBoundary>
    </div>
  );
}
